// Import modules
import Lenis from 'lenis'
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollSmoother } from "gsap/ScrollSmoother";
import { styleExternalLinks, initExternalLinkLabels } from './modules/external-link';
import { navDesktop, navMobile } from './modules/navigation';
import calculateBurgerMenuPosition from './modules/navigation/calculate-burger-menu-position';
// Sticky nav is now handled conditionally by the page-navigation block's view.js

// Define Javascript is active by changing the body class
document.body.classList.remove('no-js');
document.body.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  // Init navigation
  navDesktop();
  navMobile();
  styleExternalLinks();
  initExternalLinkLabels();

  // Calculate initial header height for mobile nav positioning
  calculateBurgerMenuPosition();

  // Initialize Lenis
  const lenis = new Lenis({
    autoRaf: true,
    smoothWheel: true,
    lerp: 0.25,
    touchMultiplier: 0,
  });

  // Make lenis globally available for navigation control
  window.lenis = lenis;

  // Listen for the scroll event and log the event data
  lenis.on('scroll', (e) => {
    console.log(e);
  });
});
